'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
const vue_1 = require('vue')
const _hoisted_1 = {
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  'enable-background': 'new 0 0 512 512',
  'xml:space': 'preserve'
}
const _hoisted_2 = /*#__PURE__*/ vue_1.createVNode(
  'g',
  null,
  [
    /*#__PURE__*/ vue_1.createVNode('g', null, [
      /*#__PURE__*/ vue_1.createVNode('path', {
        d: 'M144,268.4V358c0,6.9,4.5,14,11.4,14H184v52c0,13.3,10.7,24,24,24s24-10.7,24-24v-52h49v52c0,7.5,3.4,14.2,8.8,18.6\r\n\t\t\tc3.9,3.4,9.1,5.4,14.7,5.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c13.3,0,24-10.7,24-24v-52h27.6c7,0,11.4-7.1,11.4-13.9v-89.6V192\r\n\t\t\tH144V268.4z'
      }),
      /*#__PURE__*/ vue_1.createVNode('path', {
        d: 'M408,176c-13.3,0-24,10.7-24,24v96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C432,186.7,421.3,176,408,176z'
      }),
      /*#__PURE__*/ vue_1.createVNode('path', {
        d: 'M104,176c-13.3,0-24,10.7-24,24v96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C128,186.7,117.3,176,104,176z'
      })
    ]),
    /*#__PURE__*/ vue_1.createVNode('g', null, [
      /*#__PURE__*/ vue_1.createVNode('path', {
        d: 'M311.2,89.1l18.5-21.9c0.4-0.5-0.2-1.6-1.3-2.5c-1.1-0.8-2.4-1-2.7-0.4l-19.2,22.8c-13.6-5.4-30.2-8.8-50.6-8.8\r\n\t\t\tc-20.5-0.1-37.2,3.2-50.8,8.5l-19-22.4c-0.4-0.5-1.6-0.4-2.7,0.4c-1.1,0.8-1.7,1.8-1.3,2.5l18.3,21.6\r\n\t\t\tc-48.2,20.9-55.4,72.2-56.4,87.2h223.6C366.7,161,359.6,110.4,311.2,89.1z M206.8,138.9c-7.4,0-13.5-6-13.5-13.3\r\n\t\t\tc0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C220.3,132.9,214.3,138.9,206.8,138.9z M305.2,138.9c-7.4,0-13.5-6-13.5-13.3\r\n\t\t\tc0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C318.7,132.9,312.6,138.9,305.2,138.9z'
      })
    ])
  ],
  -1
  /* HOISTED */
)
exports.default = vue_1.defineComponent({
  name: 'LogoAndroid',
  render: function render(_ctx, _cache) {
    return vue_1.openBlock(), vue_1.createBlock('svg', _hoisted_1, [_hoisted_2])
  }
})
